import React from 'react';
import { Box, BoxProps, InputAdornment, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useAtom } from 'jotai';
import { selectedWbsFilter as selectedWbsFilterAtom } from '../../state';
import { useGetPlatformId } from '@/hooks';
import { WbsFilterOption } from '@/__generated__/graphql';
import { WBS_FILTER_OPTION_LABELS } from '@/constants';

type Props = {} & BoxProps;

export const KpiCostLogWbsFilter = ({ ...rest }: Props) => {
  const [selectedWbsFilter, setSelectedWbsFilter] = useAtom(selectedWbsFilterAtom);
  const platformId = useGetPlatformId();

  // Default the panel's WBS selection to FM when it mounts with no value. Intentionally in-memory
  // only — persisting here would overwrite the platform page's saved WBS preference.
  React.useEffect(() => {
    if (selectedWbsFilter === undefined && platformId) {
      setSelectedWbsFilter(WbsFilterOption.Fm);
    }
  }, [selectedWbsFilter, platformId, setSelectedWbsFilter]);

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as WbsFilterOption;
    setSelectedWbsFilter(value);
  };

  return (
    <Box {...rest}>
      <Select
        variant="outlined"
        value={selectedWbsFilter ?? ''}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return 'Select WBS';
          return WBS_FILTER_OPTION_LABELS[selected as WbsFilterOption];
        }}
        sx={{ maxHeight: '3.5rem', width: 140 }}
        onChange={handleChange}
        id="kpi-tracker-cost-log-wbs-filter"
        endAdornment={
          selectedWbsFilter && (
            <InputAdornment
              position="end"
              sx={{
                position: 'absolute',
                right: 25,
                pointerEvents: 'none',
              }}
            ></InputAdornment>
          )
        }
      >
        {Object.values(WbsFilterOption).map((option) => (
          <MenuItem key={option} value={option}>
            {WBS_FILTER_OPTION_LABELS[option]}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
